import React from 'react';
import { Badge, Media, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import createMarkup from '../../../_utils/murkup';
import DeleteButton from '../common/Buttons/DeleteButton.jsx';

const AphorismsItem = (props) => {
  const handleDelete = () => {
    props.onDelete(props.id, props.checked);
  }

  return <Media className='media-border-bottom my-3'>
    <Media.Body className='flex-wrap'>
      <p><span className='font-weight-bold'>{ gettext('Автор') }:</span> { props.author ? props.author : gettext('неуказан') }</p>
      <div dangerouslySetInnerHTML={ createMarkup(props.content) }></div>
      <Row className='my-2'>
        <Col xs={12} sm={6}>
          { !props.checked && <Badge variant='danger' className='mr-2'>{ gettext('На модерации') }</Badge> }
        </Col>
        <Col xs={12} sm={6} className='text-md-right'>
          <DeleteButton id={ props.id } title={ gettext('Удалить') } text={ gettext('Удалить') } onDeleteClick={ handleDelete }/>
        </Col>
      </Row>
    </Media.Body>
    </Media>
};


AphorismsItem.propTypes = {
  id: PropTypes.number.isRequired,
  author: PropTypes.string,
  content: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
};

export default AphorismsItem;

